export const isValidImageUrl = (avatarUrl?: string | null) => {
  if (!avatarUrl) return false;

  return new RegExp(/\.(gif|jpe?g|tiff?|png|webp|bmp|svg)$/i).test(avatarUrl);
};
